export const epinHero = {
  eyebrow: '客户案例 · 重点案例',
  title: 'ePin食安码',
  titleHighlight: '一物一码 · 全链路食安溯源',
  subtitle: '为每一件农产品赋予可信数字身份，从生产建档、质检赋码到流通销售，全链路可查、可验、可追溯。',
  desc: '覆盖农户、村集体、质检机构、县域服务中心、物流仓储、商户、消费者、平台运营与监管审计九大角色的协同体系，让食品安全看得见。',
  imageUrl:
    'https://readdy.ai/api/search-image?query=Abstract%20one-item-one-code%20food%20safety%20traceability%20concept%2C%20a%20glowing%20QR%20code%20node%20connected%20through%20a%20supply%20chain%20network%20of%20farm%2C%20warehouse%2C%20truck%20and%20retail%20icons%2C%20deep%20graphite%20background%20with%20warm%20gold%20and%20fresh%20green%20accents%2C%20clean%20minimal%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=epin-hero-01&orientation=landscape',
};

export const epinIntro = {
  title: '什么是 ePin食安码',
  desc: 'ePin食安码以「一物一码」为核心，为产品、批次或单品分配唯一编码。编码贯穿生产建档、质量检测、仓储物流、商品上架到消费者扫码的全过程，任一环节都可回溯到责任主体与原始记录，做到来源可查、去向可追、责任可究。',
};

export const epinStats = [
  { value: '9', unit: '大角色', label: '生产到监管全角色协同' },
  { value: '8', unit: '步流程', label: '从生产建档到售后召回' },
  { value: '10', unit: '个状态', label: '编码状态全程可流转' },
  { value: '一物', unit: '一码', label: '唯一编码绑定责任主体' },
];

export interface EpinRoleModule {
  title: string;
  desc: string;
}

export interface EpinRole {
  key: string;
  name: string;
  scope: string;
  summary: string;
  icon: string;
  modules: EpinRoleModule[];
  rule?: string;
}

export const epinRoles: EpinRole[] = [
  {
    key: 'farmer',
    name: '农户 / 生产者',
    scope: '生产主体档案、产品建档、生产记录、批次管理、赋码申请',
    summary: '维护产地、种植 / 养殖、采摘 / 出栏、加工等生产信息；提交 ePin 赋码申请。',
    icon: 'ri-plant-line',
    modules: [
      { title: '主体档案维护', desc: '身份、合作社 / 企业信息、经营资质、产地及联系方式。' },
      { title: '产品建档', desc: '新建产品、规格、品类、生产批次、保质期、包装规格。' },
      { title: '生产过程记录', desc: '播种 / 投苗、种植养殖、投入品、采摘 / 出栏、初加工等事件。' },
      { title: '凭证上传', desc: '上传图片、视频、检测材料、票据或其他证明材料。' },
      { title: 'ePin 申请', desc: '为产品、批次或单品申请唯一 ePin。' },
      { title: '状态查询', desc: '查看待审核、待质检、已编码、已上架、冻结等状态。' },
      { title: '异常处理', desc: '提交资料补录、更正申请和质量异常说明。' },
    ],
    rule: '生产者仅可维护本人或本主体授权范围内的产品及记录；原始记录不能覆盖，只能发起补录或更正。',
  },
  {
    key: 'village',
    name: '村集体 / 乡村云调度',
    scope: '生产者管理、产能组织、产品汇集、资料初审、上架协同',
    summary: '管理本村生产主体和产品资源，组织样品送检，协同产品入仓及上架。',
    icon: 'ri-community-line',
    modules: [
      { title: '生产主体管理', desc: '审核和维护辖区农户、合作社、生产企业信息。' },
      { title: '产能汇集', desc: '汇总产品品类、预计产量、供货周期和库存情况。' },
      { title: '产品初审', desc: '校验基础资料、产地信息、生产记录和申请材料完整性。' },
      { title: '样品送检', desc: '协同发起送检、跟踪检测进度、补充检测材料。' },
      { title: '商品组织', desc: '组织合格商品入仓、关联云厨菜单、申请上架。' },
      { title: '区域看板', desc: '查看区域产品数、已赋码率、质检合格率、销售及异常情况。' },
      { title: '异常协同', desc: '协调冻结、召回、投诉处理和生产者整改。' },
    ],
  },
  {
    key: 'qc',
    name: '品控 / 质检机构',
    scope: '质量判定、异常提报',
    summary: '接收检测任务，录入检测结果与报告，对不合格产品进行判定与风险提报。',
    icon: 'ri-flask-line',
    modules: [
      { title: '检测任务', desc: '接收样品检测和资质审核任务。' },
      { title: '检测项目管理', desc: '配置或选择检测项目、标准、检测期限和判定规则。' },
      { title: '检测结果录入', desc: '录入检测数值、结论、报告编号和有效期。' },
      { title: '质检报告上传', desc: '检测报告及相关凭证。' },
      { title: '合格判定', desc: '标记合格、不合格、待补充或复检。' },
      { title: '风险提报', desc: '对质量异常产品发起冻结、召回或黑榜建议。' },
      { title: '质量追踪', desc: '查询检测历史、复检记录和整改结果。' },
    ],
    rule: '核心规则：未完成质检审核或质检不通过的产品，不得生成可销售状态。',
  },
  {
    key: 'county',
    name: '县域服务中心',
    scope: '质量监管、异常处置',
    summary: '管理辖区商品池与审核流程，对上架申请终审，并监管区域质量与异常。',
    icon: 'ri-building-2-line',
    modules: [
      { title: '区域商品池', desc: '管理辖区商品、生产主体、批次和 ePin 总量。' },
      { title: '上架审批', desc: '审核产品资料、质检结论、供应能力及云厨菜单关联申请。' },
      { title: '区域规则配置', desc: '区域品类、准入标准、审核流程和预警阈值。' },
      { title: '质量监管', desc: '查看异常商品、质检失效、召回进度和整改情况。' },
      { title: '数据看板', desc: '查看赋码覆盖率、链路完整率、在售商品数和投诉情况。' },
      { title: '区域追溯', desc: '按产品、批次、生产者、订单或 ePin 查询全链路信息。' },
      { title: '审核留痕', desc: '保留审核人、审核时间、审核意见和状态变化记录。' },
    ],
  },
  {
    key: 'logistics',
    name: '物流 / 仓储方',
    scope: '异常上报',
    summary: '扫码确认出入库，记录运输与交接节点，形成完整流转轨迹。',
    icon: 'ri-truck-line',
    modules: [
      { title: '入库管理', desc: '扫描 ePin、确认货物、记录仓库、数量、时间和质检状态。' },
      { title: '出库管理', desc: '关联订单或调拨单，记录出库时间、去向和操作人员。' },
      { title: '运输管理', desc: '记录承运方、车辆、运输时间、路线和交接信息。' },
      { title: '节点交接', desc: '通过扫码确认转运、签收、拒收、破损或温控异常。' },
      { title: '配送履约', desc: '关联消费者订单，更新配送、妥投或自提状态。' },
      { title: '异常上报', desc: '上报破损、超期、温控异常、错发和丢失等事件。' },
      { title: '轨迹查询', desc: '查询本人负责商品的流通轨迹和任务状态。' },
    ],
    rule: '所有物流事件均应追加至 ePin 事件表，不能修改或覆盖既有事件。',
  },
  {
    key: 'merchant',
    name: '云店长 / 商户',
    scope: '销售、订单履约、售后',
    summary: '选品上架、关联云厨菜单与数字货架，负责销售、配送或自提服务。',
    icon: 'ri-store-3-line',
    modules: [
      { title: '商品选品', desc: '查看已审核、可销售的 ePin 商品。' },
      { title: '数字货架', desc: '将商品关联至数字货架、云厨菜单或门店商品池。' },
      { title: '商品展示', desc: '配置商品图文、库存、销售渠道和售后规则。' },
      { title: '订单管理', desc: '查看订单、发货、配送、自提、签收和售后状态。' },
      { title: 'ePin 查询', desc: '按商品、订单或扫码结果查询溯源与质量信息。' },
      { title: '销售关联', desc: '将 ePin 与云厨菜单、订单、门店和消费者订单关联。' },
      { title: '售后管理', desc: '处理退货、换货、投诉、质量反馈和召回通知。' },
      { title: '经营看板', desc: '查看商品销售、扫码次数、质量异常、退货和评价情况。' },
    ],
    rule: '商户仅能销售「已上架且未冻结 / 未召回」的 ePin 商品。',
  },
  {
    key: 'consumer',
    name: '消费者',
    scope: '扫码查询、购买、评价、投诉举报、售后申请',
    summary: '扫码查看商品食安信息，下单购买、评价和维权。',
    icon: 'ri-user-smile-line',
    modules: [
      { title: 'ePin 扫码查询', desc: '扫码查看商品的食安、产地、检测、物流和销售信息。' },
      { title: '商品购买', desc: '从云厨菜单或数字货架购买商品。' },
      { title: '订单履约', desc: '查看配送、自提和签收状态。' },
      { title: '收货确认', desc: '完成收货确认，触发订单后续结算条件。' },
      { title: '质量评价', desc: '对商品、物流、服务进行评价。' },
      { title: '投诉举报', desc: '针对质量、虚假信息、履约异常发起投诉或举报。' },
      { title: '售后申请', desc: '提交退货、换货、退款或质量问题申请。' },
      { title: '召回提醒', desc: '接收已购商品的冻结、异常或召回通知。' },
    ],
    rule: '生产者个人信息、物流人员信息和收益账户信息默认脱敏。',
  },
  {
    key: 'platform',
    name: '平台运营后台',
    scope: '编码规则、权限管理、链路管理、分账关联、风控、审计、接口管理',
    summary: '维护 ePin 全局规则、状态流转、数据权限、异常冻结及系统集成。',
    icon: 'ri-settings-3-line',
    modules: [
      { title: '编码规则管理', desc: '配置 ePin 生成规则、编码颗粒度、二维码格式和防伪策略。' },
      { title: '产品与批次管理', desc: '管理产品、批次、包装、拆分、合并和失效规则。' },
      { title: '状态流转管理', desc: '管理草稿、质检、赋码、上架、流通、售后、冻结、归档等状态。' },
      { title: '角色权限管理', desc: '配置生产者、质检方、商户、物流方、监管方的数据范围和操作权限。' },
      { title: '事件链路管理', desc: '统一管理生产、检测、仓储、运输、销售、售后等事件记录。' },
      { title: '异常与召回', desc: '冻结产品、限制销售、发起召回、通知商户和消费者。' },
      { title: '收益关联', desc: '将 ePin 与订单、参与主体、贡献类型、分账规则及数字人民币流水关联。' },
      { title: '风控防伪', desc: '识别异常重复扫码、异地扫码、伪造码和异常流通轨迹。' },
      { title: '审计导出', desc: '按产品、批次、主体、订单、时间范围导出链路数据。' },
      { title: '开放接口', desc: '向数字货架、订单、物流、支付、监管系统提供 API 服务。' },
    ],
  },
  {
    key: 'regulator',
    name: '监管 / 审计角色',
    scope: '审计导出、召回监督',
    summary: '按编码、产品、批次或订单核验全链路记录，监督召回与整改。',
    icon: 'ri-file-shield-2-line',
    modules: [
      { title: '全链路追溯', desc: '按 ePin、产品、批次、订单或生产主体查询完整记录。' },
      { title: '质检监管', desc: '查询检测报告、失效情况、复检结果和异常记录。' },
      { title: '异常监管', desc: '查看冻结、召回、投诉、整改和处理时效。' },
      { title: '分账核验', desc: '查询产品关联订单、参与主体、贡献节点和分账摘要。' },
      { title: '审计导出', desc: '导出带时间、操作人、审批记录和版本信息的审计材料。' },
      { title: '数据统计', desc: '查看区域赋码率、合格率、召回率、投诉率和链路完整率。' },
    ],
  },
];

export const epinPermissions = [
  {
    role: '生产者',
    icon: 'ri-plant-line',
    rule: '仅可维护本人或本主体授权范围内的产品及记录；原始记录不能覆盖，只能发起补录或更正。',
  },
  {
    role: '品控 / 质检机构',
    icon: 'ri-flask-line',
    rule: '未完成质检审核或质检不通过的产品，不得生成可销售状态。',
  },
  {
    role: '物流 / 仓储方',
    icon: 'ri-truck-line',
    rule: '所有物流事件均应追加至 ePin 事件表，不能修改或覆盖既有事件。',
  },
  {
    role: '云店长 / 商户',
    icon: 'ri-store-3-line',
    rule: '仅能销售「已上架且未冻结 / 未召回」的 ePin 商品。',
  },
  {
    role: '消费者',
    icon: 'ri-user-smile-line',
    rule: '生产者个人信息、物流人员信息和收益账户信息默认脱敏。',
  },
  {
    role: '平台 / 监管',
    icon: 'ri-file-shield-2-line',
    rule: '召回与归档记录不可删除，审计材料完整保留时间、操作人、审批记录与版本。',
  },
];

export interface EpinScanQc {
  name: string;
  result: string;
  org: string;
}

export interface EpinScanNode {
  node: string;
  time: string;
  place: string;
  desc: string;
  icon: string;
}

export interface EpinScanResult {
  code: string;
  product: string;
  category: string;
  spec: string;
  batch: string;
  origin: string;
  producer: string;
  harvestDate: string;
  shelfLife: string;
  status: string;
  tone: 'ok' | 'warn';
  qc: EpinScanQc[];
  nodes: EpinScanNode[];
}

// 模拟扫码溯源的示例数据（用于页面对话式演示）
export const epinScanSamples: EpinScanResult[] = [
  {
    code: 'epn_jgan_b_7f3a91c2d4',
    product: '尤溪金柑 · 精品礼盒',
    category: '水果 / 柑橘类',
    spec: '2.5kg / 箱（精品礼盒）',
    batch: 'JG2025-0301',
    origin: '福建尤溪 · 中仙产区',
    producer: '尤溪县中仙生态果业专业合作社',
    harvestDate: '2025-09-15',
    shelfLife: '常温阴凉通风，25 天',
    status: '流通正常',
    tone: 'ok',
    qc: [
      { name: '农药残留（48 项）', result: '合格', org: '三明市农产品质量安全检测中心' },
      { name: '可溶性固形物（甜度）', result: '15.6° 合格', org: '尤溪县果业技术推广站' },
      { name: '重金属（铅 / 镉）', result: '合格', org: '三明市农产品质量安全检测中心' },
    ],
    nodes: [
      { node: '生产建档', time: '08-20 08:40', place: '尤溪县中仙乡果园', desc: '录入果园地块、树龄与施肥用药记录', icon: 'ri-plant-line' },
      { node: '质检赋码', time: '09-15 10:20', place: '尤溪果品检测站', desc: '糖度与农残检测合格，生成礼盒 ePin', icon: 'ri-flask-line' },
      { node: '预冷入库', time: '09-15 18:10', place: '三明果品仓储中心', desc: '预冷后扫码入库 620 箱', icon: 'ri-archive-2-line' },
      { node: '干线运输', time: '09-16 06:50', place: '福银高速三明段', desc: '常温厢式车闽G·K07A，运输轨迹正常', icon: 'ri-truck-line' },
      { node: '门店上架', time: '09-17 09:30', place: '华辉云铺 · 中仙礼盒专区', desc: '上架礼盒专区并关联当季营销活动', icon: 'ri-store-3-line' },
      { node: '消费签收', time: '09-18 15:20', place: '福州市鼓楼区', desc: '消费者扫码查看溯源后下单签收', icon: 'ri-user-smile-line' },
    ],
  },
  {
    code: 'EPIN-CQ-20250918-000873',
    product: '清远走地鸡（鲜活）',
    category: '禽类 / 鲜活农产品',
    spec: '约 1.6kg / 只',
    batch: 'CQ20250918-A3',
    origin: '广东省清远市清城区源潭镇',
    producer: '清远源潭生态养殖专业合作社',
    harvestDate: '2025-09-18',
    shelfLife: '冷藏 0–4℃，3 天',
    status: '流通正常',
    tone: 'ok',
    qc: [
      { name: '兽药残留（氯霉素）', result: '合格', org: '清远市农产品质量检测中心' },
      { name: '禽流感病毒核酸', result: '合格', org: '广东省动物疫病预防控制中心' },
      { name: '菌落总数', result: '合格', org: '清远市农产品质量检测中心' },
    ],
    nodes: [
      { node: '生产建档', time: '09-10 08:30', place: '源潭镇生态养殖基地', desc: '建立主体与产品档案，录入养殖批次与投入品记录', icon: 'ri-plant-line' },
      { node: '质检赋码', time: '09-18 10:15', place: '县域服务中心质检站', desc: '抽检合格，生成唯一 ePin 并绑定批次信息', icon: 'ri-flask-line' },
      { node: '冷链入库', time: '09-18 16:40', place: '清城冷链中心 B 区', desc: '扫码入库，温度 2.4℃，数量 480 只', icon: 'ri-archive-2-line' },
      { node: '冷链运输', time: '09-19 06:20', place: '京港澳高速清远段', desc: '冷链车粤R·D8K21，全程温控记录正常', icon: 'ri-truck-line' },
      { node: '门店上架', time: '09-19 11:05', place: '华辉云铺 · 帝星社区店', desc: '云店长扫码收货并上架数字货架', icon: 'ri-store-3-line' },
      { node: '消费签收', time: '09-20 18:32', place: '广州市天河区', desc: '消费者下单签收，订单进入已完成状态', icon: 'ri-user-smile-line' },
    ],
  },
  {
    code: 'EPIN-YN-20250912-002451',
    product: '云南高山娃娃菜',
    category: '蔬菜 / 叶菜类',
    spec: '500g / 袋（3 颗装）',
    batch: 'YN20250912-S7',
    origin: '云南省昆明市嵩明县杨林镇',
    producer: '嵩明高原蔬菜种植联合社',
    harvestDate: '2025-09-12',
    shelfLife: '冷藏 0–4℃，5 天',
    status: '流通正常',
    tone: 'ok',
    qc: [
      { name: '农药残留（48 项）', result: '合格', org: '昆明市农产品质量安全中心' },
      { name: '重金属（铅 / 镉）', result: '合格', org: '昆明市农产品质量安全中心' },
      { name: '硝酸盐含量', result: '合格', org: '云南省农业科学院检测中心' },
    ],
    nodes: [
      { node: '生产建档', time: '08-20 09:00', place: '嵩明县杨林镇种植基地', desc: '录入播种、种植与采收计划，绑定地块信息', icon: 'ri-plant-line' },
      { node: '质检赋码', time: '09-12 09:40', place: '昆明市质检中心', desc: '抽检合格，生成唯一 ePin 并打印标签', icon: 'ri-flask-line' },
      { node: '分拣入库', time: '09-12 15:10', place: '嵩明蔬菜分拣中心', desc: '分拣打包，扫码入库 1,200 袋', icon: 'ri-archive-2-line' },
      { node: '干线运输', time: '09-13 05:30', place: '沪昆高速嵩明段', desc: '冷藏车云A·K92M，全程 0–4℃ 温控', icon: 'ri-truck-line' },
      { node: '门店上架', time: '09-13 14:20', place: '华辉云铺 · 春城旗舰店', desc: '上架数字货架，同步云厨菜单', icon: 'ri-store-3-line' },
      { node: '消费签收', time: '09-14 12:05', place: '昆明市五华区', desc: '消费者扫码核验后签收', icon: 'ri-user-smile-line' },
    ],
  },
  {
    code: 'EPIN-GX-20250905-001207',
    product: '赣南脐橙（精品礼盒）',
    category: '水果 / 柑橘类',
    spec: '5kg / 箱',
    batch: 'GX20250905-P2',
    origin: '江西省赣州市信丰县安西镇',
    producer: '信丰脐橙产业合作社',
    harvestDate: '2025-09-05',
    shelfLife: '常温阴凉，30 天',
    status: '流通正常',
    tone: 'ok',
    qc: [
      { name: '农药残留（64 项）', result: '合格', org: '赣州市农产品质量检测中心' },
      { name: '可溶性固形物（甜度）', result: '13.2° 合格', org: '信丰县果业技术站' },
      { name: '重金属（铅）', result: '合格', org: '赣州市农产品质量检测中心' },
    ],
    nodes: [
      { node: '生产建档', time: '08-15 08:40', place: '信丰县安西镇果园', desc: '录入果园地块、树龄与施肥用药记录', icon: 'ri-plant-line' },
      { node: '质检赋码', time: '09-05 10:50', place: '信丰果品检测站', desc: '糖度与农残检测合格，生成礼盒 ePin', icon: 'ri-flask-line' },
      { node: '预冷入库', time: '09-05 18:30', place: '赣州果品仓储中心', desc: '预冷后扫码入库 800 箱', icon: 'ri-archive-2-line' },
      { node: '干线运输', time: '09-06 07:10', place: '赣粤高速赣州段', desc: '常温厢式车赣B·L31H，运输轨迹正常', icon: 'ri-truck-line' },
      { node: '门店上架', time: '09-07 10:00', place: '华辉云铺 · 帝星礼盒专区', desc: '上架礼盒专区并关联节日营销活动', icon: 'ri-store-3-line' },
      { node: '消费签收', time: '09-08 16:45', place: '深圳市南山区', desc: '消费者扫码查看溯源后下单签收', icon: 'ri-user-smile-line' },
    ],
  },
  {
    code: 'EPIN-SD-20250830-004492',
    product: '寿光番茄（串收）',
    category: '蔬菜 / 茄果类',
    spec: '1kg / 盒',
    batch: 'SD20250830-T4',
    origin: '山东省潍坊市寿光市田柳镇',
    producer: '寿光田柳设施蔬菜基地',
    harvestDate: '2025-08-30',
    shelfLife: '冷藏 8–10℃，7 天',
    status: '已冻结 · 待复检',
    tone: 'warn',
    qc: [
      { name: '农药残留（毒死蜱）', result: '不合格', org: '潍坊市农产品质量检测中心' },
      { name: '外观与规格', result: '合格', org: '寿光市果蔬质检站' },
    ],
    nodes: [
      { node: '生产建档', time: '07-18 09:20', place: '田柳镇设施蔬菜基地', desc: '录入大棚编号、定植与用药记录', icon: 'ri-plant-line' },
      { node: '质检赋码', time: '08-30 10:05', place: '寿光果蔬质检站', desc: '抽检发现农残超标，暂缓赋码并转入复核', icon: 'ri-flask-line' },
      { node: '冻结处置', time: '08-30 15:30', place: '平台风控中心', desc: '对应批次 ePin 商品冻结，禁止上架与销售', icon: 'ri-error-warning-line' },
      { node: '复检送样', time: '08-31 09:00', place: '潍坊市农产品质量检测中心', desc: '重新取样送检，等待复检结论', icon: 'ri-test-tube-line' },
      { node: '召回监督', time: '08-31 11:20', place: '县域服务中心', desc: '已流通商品进入召回流程，记录全过程留痕', icon: 'ri-alarm-warning-line' },
    ],
  },
];

export const epinScanDefault = epinScanSamples[0];

// 全程溯源流程 · 八步（合并原「全链路溯源链路图」与「核心业务流程」）
export interface EpinFullFlowStep {
  no: string;
  icon: string;
  name: string;
  desc: string;
}

export const epinFullFlow: EpinFullFlowStep[] = [
  {
    no: '01',
    icon: 'ri-seedling-line',
    name: '播种 / 投苗建档',
    desc: '生产者创建主体与产品档案，录入地块、品种、批次与投入品信息，形成产品最初的数据源头。',
  },
  {
    no: '02',
    icon: 'ri-plant-line',
    name: '种植 / 养殖管理',
    desc: '持续记录农事 / 养殖作业、环境数据与投入品使用，沉淀完整的生长过程档案。',
  },
  {
    no: '03',
    icon: 'ri-leaf-line',
    name: '采摘 / 出栏',
    desc: '达到采收或出栏标准后登记时间与数量，批次与产地信息一并绑定。',
  },
  {
    no: '04',
    icon: 'ri-flask-line',
    name: '检测与审核',
    desc: '样品送检并由质检机构出具结论，村集体初审、县域服务中心终审通过后方可放行。',
  },
  {
    no: '05',
    icon: 'ri-qr-code-line',
    name: '包装赋码',
    desc: '合格产品按包装规格生成唯一 ePin，一物一码绑定全部生产与质检档案。',
  },
  {
    no: '06',
    icon: 'ri-truck-line',
    name: '入仓与运输',
    desc: '扫码完成出入库与交接，记录仓库、数量、温控、承运方与运输轨迹。',
  },
  {
    no: '07',
    icon: 'ri-store-3-line',
    name: '上架、购买与履约',
    desc: '商品上架数字货架与云厨菜单，消费者扫码购买并完成配送、自提或核销。',
  },
  {
    no: '08',
    icon: 'ri-customer-service-2-line',
    name: '售后、投诉与召回',
    desc: '支持评价、投诉与退货，异常商品一键冻结并触发召回，全过程留痕可审计。',
  },
];

// 首页 / 解决方案页复用的 ePin食安码入口卡片数据
export const epinSpotlight = {
  eyebrow: '重点案例 · ePin食安码',
  title: 'ePin食安码：让每一件农产品都有可信数字身份',
  desc: '从生产建档、质检赋码到仓储物流、门店销售与消费者扫码，ePin 食安码用「一物一码」把食品安全的每一环连成一条可信数据链。',
  points: [
    '生产到消费全链路可查、可验、可追溯',
    '质检不合格商品自动禁止上架销售',
    '物流节点扫码留痕，记录不可覆盖',
    '异常冻结与召回全过程留档可审计',
  ],
  primaryCta: '了解 ePin食安码',
  href: '/cases/epin-food-safety',
  secondaryCta: '查看溯源档案示例',
  secondaryHref: '/solutions/smart-agriculture/trace',
  imageUrl:
    'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20one%20item%20one%20code%20food%20safety%20traceability%2C%20a%20luminous%20QR%20code%20connected%20to%20farm%20field%2C%20inspection%20lab%2C%20warehouse%20and%20delivery%20truck%20icons%2C%20graphite%20dark%20background%20with%20warm%20gold%20and%20fresh%20green%20accents%2C%20clean%20minimal%20cinematic%20editorial%20style%2C%20soft%20glow%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=900&seq=epin-spotlight-01&orientation=landscape',
};